export const COM_1045_TEST_NAME = 'google_sso_com1045_test_20230222';
export const COM_1045_TEST_PERCENT = 0.5;

export const AUTOPROGRESS_TIMEOUT_MS = 500;
export const CONTINUE_LOADING_TIMEOUT_MS = 1000;

export const COM_1138_TEST_NAME = 'google_sso_v2_com1138_20231018';
export const COM_1138_TEST_PERCENT = 0.5;

export const HZ_220_TOTAL_DUE_NOW_TEST_NAME = 'total_due_now_placement_test_hz220_20240408';
export const HZ_220_TOTAL_DUE_NOW_TEST_PERCENT = 0.5;
